import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";

export const CopyExerciseComponent = ({ className, exercises, athlete }) => {
  /**
   * Function to copy exercises in the session storage
   * @param {*} e
   */
  const handleCopyExercises = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (exercises && athlete) {
      const exercisesArray = Array.isArray(exercises) ? exercises : [exercises];
      if (exercisesArray.length > 0) {
        const { exerciseLibrary } = athlete;
        const exercisesOfExerciseLibrary = getExercisesOfExerciseLibrary(
          exerciseLibrary,
          exercisesArray
        );
        submit(`/actions/exercise/copy-exercises`, {
          method: "POST",
          body: {
            exercises: exercisesArray,
            originalAthleteLibrary: exercisesOfExerciseLibrary,
          },
        });
      }
    }
  };

  /**
   * Function to save the exercise library with the exercise to paste of the original athlete
   * @param {*} library
   * @param {*} exercises
   * @returns
   */
  const getExercisesOfExerciseLibrary = (library, exercises) => {
    const libraryToReturn = [];
    exercises.forEach((exercise) => {
      const { primary, secondary } = exercise;

      if (secondary) {
        const foundItem = library[primary]?.find(({ movement }) => {
          return movement === secondary;
        });

        if (foundItem) {
          libraryToReturn.push(foundItem);
        }
      }
    });
    return libraryToReturn;
  };

  return (
    <button
      id="button-local-copy"
      className={className}
      onClick={handleCopyExercises}
    >
      <img
        src="/img/new-icons/vuesax-linear-document-copy.svg"
        alt="Copy Exercise Icon"
      />
    </button>
  );
};

CopyExerciseComponent.propTypes = {
  classNames: PropTypes.string,
  exercises: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  athlete: PropTypes.object,
};
